import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-097e2a46")

_pushScopeId("data-v-097e2a46")
const _hoisted_1 = {
  class: "container",
  id: "order-actions"
}
const _hoisted_2 = { class: "actions-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-confirm fs-26" })
], -1)
const _hoisted_4 = { class: "action-text" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-share fs-26" })
], -1)
const _hoisted_6 = { class: "action-text" }
const _hoisted_7 = { class: "action-text" }
const _hoisted_8 = { class: "actions-row text-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "action-btn with-word-spacing action-green",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelectQuoteAction('create-order')))
      }, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('label.create-order')), 1)
      ]),
      _createVNode("div", {
        class: "action-btn with-word-spacing",
        style: {"background":"linear-gradient(to bottom, #00e1ef, #00bfdb)"},
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSelectQuoteAction('share')))
      }, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('documents.share')), 1)
      ]),
      _createVNode("div", {
        class: "action-btn with-word-spacing action-red",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSelectQuoteAction('delete-quote')))
      }, [
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('label.delete-quote')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
        class: "action-btn-back"
      }, _toDisplayString(_ctx.$t('button.close')), 1)
    ])
  ]))
})